import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import React from 'react'
import { Link } from 'react-router-dom'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit'
import LeaderboardsStore from './store/LeaderboardsPage.store'
import UserProfileService from '../../shared/services/UserProfile.service'
import { OUTPUT_MODE_PERIODS, toSearch } from './store/BigScreen.store'
import { BIG_SCREEN_USERTYPES } from './variables'
import LeaderboardConfigurator from './components/LeaderboardConfigurator/LeaderboardConfigurator.component'
import CurrentTopPip from './components/CurrentTopPip/CurrentTopPip.component'
import BreakTheBarDetails from './../../components/shared/BreakTheBarDetails/BreakTheBarDetails.component'
import LeaderboardsResultsTable from './components/LeaderboardsResultsTable/LeaderboardsResultsTable.component'
import ContentHtml from '../../components/content/ContentHtml/ContentHtml.component'
import './LeaderboardsPage.scss'

// Opens Big Screen on the board this page is showing.
const getBigScreenUrl = () => {
  const params = toJS(LeaderboardsStore.fetchParams)
  return (
    '/big-screen' +
    toSearch({
      boards: ['leaderboard'],
      metric: params.type || 'points',
      group: params.agent_type || 'user_id',
      category: [].concat(params.categories || [])[0] || '',
      no_aca: !!params.opts?.remove_aca_av,
      division_id: params.division_id || '',
      team_id: params.team_id || '',
      period: OUTPUT_MODE_PERIODS[params.output_mode] || 'week',
    })
  )
}

const LeaderboardsPageComponent = () => {
  let type
  switch (toJS(LeaderboardsStore.fetchParams).type) {
    case 'points':
      type = 'Points'
      break
    case 'av':
      type = 'AV'
      break
    case 'aca_lives':
      type = 'ACA Lives'
      break
    default:
      break
  }

  return (
    <>
      <DashboardLayout>
        <main id='LeaderboardsPage' className='adminStyle mainSection pb-5'>
          <MDBContainer fluid className='mt-2'>
            <MDBRow className='report-title'>
              <MDBCol size='12' md='5'>
                <h2>
                  {type} Leaderboard
                  {UserProfileService.isA(BIG_SCREEN_USERTYPES) && (
                    <Link to={getBigScreenUrl()} className='btn btn-sm btn-indigo big-screen-link'>
                      <MDBIcon icon='tv' /> Big Screen
                    </Link>
                  )}
                </h2>
                <ContentHtml contentSlug='weekly-break-bar-instruction' />
              </MDBCol>
              <MDBCol size='12' md='7'>
                {type === 'Points' ? <BreakTheBarDetails agentScope={LeaderboardsStore.getAgentScope()} /> : <></>}
              </MDBCol>
            </MDBRow>
            <hr />
          </MDBContainer>
          <CurrentTopPip />
          <LeaderboardConfigurator />
          <LeaderboardsResultsTable isFetching={LeaderboardsStore.isFetching} />
        </main>
      </DashboardLayout>
    </>
  )
}

const LPC = observer(LeaderboardsPageComponent)

class LeaderboardsPage extends React.Component {
  render() {
    return <LPC />
  }
}

export default LeaderboardsPage
